export const VALIDATE_CLIENT_ENDPOINT = "/auth/validate-client";
